import React from 'react'
import {
  deleteTemplate,
  renameTemplate
} from 'report-components/lib/reducers'
import {withToggles, withDialogError} from 'startlibs/lib/hocs'
import {Errors, Form, withForm, TextInput} from 'startlibs/lib/form'
import {Dialog, Button} from 'startlibs/lib/components'
import {connect} from 'react-redux'
import {deleteAvailableSignature} from '../../../reducers'

@withDialogError
@connect(undefined,{deleteAvailableSignature})
@withToggles('deleteDialog','isLoading')
export class ManageSignaturesDialog extends React.Component {

  deleteSignature = () => {
    this.props.isLoading.open()
    this.props
      .deleteAvailableSignature(this.props.deleteDialog.isOpen)
      .then(() =>
        this.props.isLoading.close() ||
        this.props.deleteDialog.close()
      )
  }

  render() {
    const {signatures, enabledSignatures, closeDialog, openCreateSignature, isLoading, deleteDialog} = this.props
    return <Dialog
      className='manage-template-dialog'
      title='Manage signatures'
      closeDialog={closeDialog}
    >
      <Dialog.Content>
        <p>
          Click below to add or delete signatures
        </p>
        {enabledSignatures.map(signatureId =>
          <SignatureBox
            key={signatureId}
            signature={signatures[signatureId]}
            openDeleteDialog={()=>deleteDialog.open(signatureId)}
          />
        )}
        {enabledSignatures.length === 0 && <div className="no-templates">
          <h3>You currently have no signatures.</h3>
        </div>
        }
      </Dialog.Content>

      <Dialog.Footer>
        <Dialog.FooterAuxiliaryContainer>
          <Button highlight onClick={openCreateSignature}>Create new signature</Button>
        </Dialog.FooterAuxiliaryContainer>
        <Button onClick={closeDialog}>Close</Button>
      </Dialog.Footer>
      {
        deleteDialog.isOpen!==false &&
        <Dialog
          title="Confirm delete signature"
          closeDialog={deleteDialog.close}
        >
          <Dialog.Content>
            You are about to delete the signature <strong>{(signatures[deleteDialog.isOpen]||{}).name}</strong>. Reports already created will not be affected. Confirm deletion?
          </Dialog.Content>
          <Dialog.Footer>
            <Button onClick={deleteDialog.close}>Cancel</Button>
            <Button alert isLoading={isLoading.isOpen} onClick={this.deleteSignature} type="submit">Delete</Button>
          </Dialog.Footer>
        </Dialog>
      }
    </Dialog>
  }
}

const SignatureBox = ({signature, openDeleteDialog}) => (
  <div className="editable-box">
    {signature.name}
    <button className="small-button" onClick={openDeleteDialog}>
      Delete
    </button>
  </div>
)



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/signatures/ManageSignaturesDialog.jsx